import { render, staticRenderFns } from "./CompanyDepartmentsPage.vue?vue&type=template&id=5d08330a"
import script from "./CompanyDepartmentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDepartmentsPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports